var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:'inline-block w-3 h-3 mr-2 rounded-sm ' + _vm.realmColor})
}
var staticRenderFns = []

export { render, staticRenderFns }